export const useSearchNavigateToFilters = () => {
  const { filters, page } = storeToRefs(useSearchStore())
  const { map: equipmentReferentialMap } = useReferentialMap('vehicle_equipments')

  return {
    navigateToFilters: async () => {
      const query = buildSearchQueryFilters(filters.value, {}, equipmentReferentialMap.value)
      query.page = '1'
      page.value = 1
      await navigateTo({ query })
    },
  }
}
